import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsappFloat() {

  const comboTexts = [
  "🔥Combo Deals on WhatsApp",
  "💬 Order Combo ⬇",
  "👕 T-Shirt Combo ⬇",
  "🎁 Combo Offers ⬇",
  "🔥Combo Deals on WhatsApp",
  "🧥 Hoodie Combo ⬇",
  "⚡ Limited Combos ⬇",
  "👔 Polo Combo ⬇",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % comboTexts.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const message = "Hi! I want to grab a combo offers from DAXMA.";
const whatsappLink = `https://wa.me/919361454100?text=${encodeURIComponent(message)}`;

  return (
    <div className="fixed bottom-6 right-4 z-50 flex flex-col items-end gap-2">

      {/* Text Bubble */}
      <div className="bg-[#5F6F52] text-white text-sm font-medium px-4 py-2 rounded-xl shadow-lg animate-[bounce_2s_infinite]">
        {comboTexts[index]}
      </div>

      {/* WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl hover:scale-110 transition"
      >
        <FaWhatsapp size={30} />
      </a>

    </div>
  );
}